/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_Orders_CreatedInputs */

const en_admin_funnel_col_orders_created = /** @type {(inputs: Admin_Funnel_Col_Orders_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders created`)
};

/**
* | output |
* | --- |
* | "Orders created" |
*
* @param {Admin_Funnel_Col_Orders_CreatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_orders_created = /** @type {((inputs?: Admin_Funnel_Col_Orders_CreatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_Orders_CreatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_orders_created(inputs)
});
export { admin_funnel_col_orders_created as "admin.funnel.col.orders_created" }